<template>
  <div>
    <Wp_nav_bar v-if="isShow" title="转链"></Wp_nav_bar>
    <!--            计数器-->
    <Wp_access_count page-tag="changelink"></Wp_access_count>
    <div style="padding: 10px;">
      <div>
        <Alert type="warning">
          转链步骤:<br>1.复制要转链的内容;<br>2.粘贴内容到下面文本框;<br>3.点击转链，等待完成。
        </Alert>

        <!--                <div style="font-size: 15px; color: #EE0A24; padding: 5px">-->
        <!--                    注:目前转链功能仅支持[京东]和[拼多多]-->
        <!--                </div>-->

        <van-field
            v-model="before_change_content"
            placeholder="要转链的内容粘贴在此处"
            type="textarea"
            rows="10"
            :autosize="{maxHeight: 300, minHeight: 100}"
            style="border: 1px solid #dddddd; border-radius: 4px; height: 80%"

        ></van-field>

        <div style="text-align: center;margin-top: 15px">
          <van-button type="info"
                      style="width: 48%"
                      :disabled="button_status"
                      @click="clickToChangedLink"
          >转 链
          </van-button>
          <van-button color="orange"
                      style="width: 48%; margin-left: 2%"
                      :disabled="button_status"
                      @click="clearContent"
          >清 空
          </van-button>
        </div>
        <div style="margin-top: 10px">
          <div v-if="show_loading === 1">
            <Alert :type="alert_type">
              <van-loading size="17px" color="#1989fa">
                <span style="font-size: 12px; color: #1989fa">{{ loading_text }}</span></van-loading>
            </Alert>
          </div>
          <div v-else-if="show_loading === 2">
            <Alert :type="alert_type">
              <div>
                {{ response_message }}
              </div>
            </Alert>
          </div>
        </div>

      </div>

      <van-action-sheet
          title="分享文案"
          v-model="show_paste_sheet_model"
          style="min-height: 95%"
          :round="false"
          :close-on-click-overlay="false"
          :lock-scroll="false"
          @close="sheetClosed"
      >
        <div style="padding: 10px;padding-bottom: 90px;">
          <div style="text-align: center; margin-top: 10px; margin-bottom: 10px;">
            <div v-if="img_list && img_list.length === 1">
              <Wp_image :url="img_list[0]" :width="'50'"></Wp_image>
            </div>
            <div v-else-if="img_list && img_list.length > 1">
              <Wp_image_splice
                  :img_list="img_list"
                  :max-width="600"
                  :max-height="600">
              </Wp_image_splice>
            </div>
            <!--                    <div>长按图片保存到相册</div>-->
          </div>

          <van-field
              v-model="after_change_content"
              type="textarea"
              :autosize="{maxHeight: 300, minHeight: 200}"
              style="border: 1px solid #77FFCC55; border-radius: 4px; padding: 10px; background-color: #77FFCC22"
          ></van-field>

          <div v-if="after_change_commission > 0" style="margin-top: 10px">
            <Alert type="info" style="padding-left: 10px">
              <span style="font-size: 14px; color: black">预估佣金：</span>
              <span style="font-size: 20px; color: #FF0000; ">￥{{ after_change_commission }}</span>
            </Alert>
          </div>

          <div :style="{'position': 'absolute', 'right': '10%', 'top': '45%'}">
            <van-button ref="stamp_view" type="danger" plain
                        style="width: auto; height: auto; z-index:1;border-radius: 3px;
                        padding-left: 5px; padding-right:5px; padding-top: 5px; padding-bottom: 5px;
                        display: none; background-color: #ffffff77;
                        transform: rotate(20deg)"
            >
              <van-button type="danger" plain hairline
                          style="width:100%; height: 100%;border-radius: 3px;background-color: #ffffff33; "
              ><h3>复制成功</h3>
              </van-button>
            </van-button>
          </div>

        </div>
        <!--        <div style="text-align: center; margin-top: 25px;">-->
        <div style="position: absolute;bottom: 0px;text-align: center; width: 100%; padding-top: 1px;
                                background-color: #ffffff; box-shadow: 1px -1px 5px #999999">
          <van-row v-if="skuId">
            <van-col span="4">
              <div @click="show_paste_sheet_model = false">
                <div style="text-align: center;  margin-top: 5px">
                  <van-button icon="close" size="mini"
                              style="font-size: 16px; color: #777777; background-color: rgba(0,0,0,0); border: 0px"></van-button>
                </div>
                <div style="text-align: center; color: #777777;">关闭</div>
              </div>
            </van-col>
            <van-col span="20">
              <van-row>
                <van-col
                    :span="$common.global_robot_list && $common.global_robot_list.length > 0 ? 8 : 0">
                  <Wp_join_robot_button_model ref="Wp_join_robot_button_model"
                                              style="" :sku-info="skuInfoData"
                                              :robot-list="$common.global_robot_list"
                                              :coupon-data="couponData"
                                              :at-bottom="true"

                                              @clickToJoin="joinToRobot"
                  ></Wp_join_robot_button_model>
                </van-col>
                <van-col
                    :span="$common.global_robot_list && $common.global_robot_list.length > 0 ? 8 : 12">
                  <van-button type="info"
                              size="large"
                              style="width: 100%; border-radius: 0px"
                              v-clipboard:copy="after_change_content.replace('<br/>','\n')"
                              v-clipboard:success="onCopySuccess"
                              v-clipboard:error="onError"
                  >复制文案
                  </van-button>
                </van-col>
                <van-col
                    :span="$common.global_robot_list && $common.global_robot_list.length > 0 ? 8 : 12">
                  <van-button v-if="skuId" type="danger"
                              size="large"
                              style="width: 100%; border-radius: 0px"
                              @click="showDetail"
                  >商品详情
                  </van-button>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
          <van-row v-else>
            <van-col span="4">
              <div @click="show_paste_sheet_model = false">
                <div style="text-align: center;  margin-top: 5px">
                  <van-button icon="close" size="mini"
                              style="font-size: 16px; color: #777777; background-color: rgba(0,0,0,0); border: 0px"></van-button>
                </div>
                <div style="text-align: center; color: #777777;">关闭</div>
              </div>
            </van-col>
            <van-col span="20">
              <van-button type="info"
                          size="large"
                          style="width: 100%; border-radius: 0px"
                          v-clipboard:copy="after_change_content.replace('<br/>','\n')"
                          v-clipboard:success="onCopySuccess"
                          v-clipboard:error="onError"
              >复制文案
              </van-button>
            </van-col>
          </van-row>
        </div>

        <!--        </div>-->
      </van-action-sheet>
    </div>

    <!--        <van-popup-->
    <!--                v-model="showCard"-->
    <!--                :style="{ width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0)'}"-->
    <!--        >-->
    <!--            <div :style="{width: $common.screenWidth + 'px', height: ($common.screenHeight / 2 - 150) + 'px'}"-->
    <!--                 @click="clickCloseIcon">-->
    <!--            </div>-->
    <!--            <div style="">-->

    <!--                <div v-if="skuInfoData && showCard" style="background-color: white; padding: 3px 0px">-->
    <!--                    &lt;!&ndash;                <div style="text-align: right; font-size: 13px; color: #EE0A24; margin-right: 10px; padding-top: 10px"&ndash;&gt;-->
    <!--                    &lt;!&ndash;                     @click="showSkuDetail(skuInfoData)">&ndash;&gt;-->
    <!--                    &lt;!&ndash;                    查看详情&ndash;&gt;-->
    <!--                    &lt;!&ndash;                </div>&ndash;&gt;-->
    <!--                    <Divider dashed-->
    <!--                             style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 10px; margin-bottom: 10px"></Divider>-->
    <!--                    <JdSkuInfoCard-->
    <!--                            :skuInfo="skuInfoData"-->
    <!--                            @addInSelectList="addInSelectList"-->
    <!--                    ></JdSkuInfoCard>-->
    <!--                </div>-->
    <!--                <div style="text-align: center" @click="clickCloseIcon">-->
    <!--                    <van-icon name="close" size="40" color="#FFFFFF"-->
    <!--                              style="padding-top: 50px"-->
    <!--                    />-->
    <!--                </div>-->
    <!--            </div>-->
    <!--            <div :style="{width: $common.screenWidth + 'px', height: ($common.screenHeight / 2 - 150) + 'px'}"-->
    <!--                 @click="clickCloseIcon">-->
    <!--            </div>-->
    <!--        </van-popup>-->

    <van-popup
        v-model="show_detail_model"
        position="bottom"
        :style="{ width: '100%', height: '100%' }"
    >
      <Wp_jd_sku_detail_page v-if="skuId && show_detail_model"
                             type="popup"
                             :datas="skuInfoData"
                             @clickToCloseDetail="clickToCloseDetail"
      ></Wp_jd_sku_detail_page>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Alert } from 'iview'
import { ImagePreview, Toast } from 'vant'

Vue.component('Alert', Alert)
Vue.use(ImagePreview)

import Wp_image_splice from '../custom/Wp_image_splice'
import Wp_image from '../custom/Wp_image'
import Wp_nav_bar from '../custom/Wp_nav_bar'
import Wp_jd_sku_detail_page from '../pages_childs/Wp_jd_sku_detail_page'
import Wp_access_count from '../custom/Wp_access_count'
import Wp_join_robot_button_model from '../custom/Wp_join_robot_button_model'

Vue.use(Toast)

export default {
  name: 'Wp_jd_changelink',
  components: {
    Wp_join_robot_button_model,
    Wp_access_count, Wp_jd_sku_detail_page, Wp_nav_bar, Wp_image, Wp_image_splice
  },
  data () {
    return {
      loading_text: '转链中，请稍后...',
      show_paste_sheet_model: false,
      before_change_content: '',
      after_change_content: '',
      after_change_commission: 0,
      show_loading: 0,//0不显示，1转链时显示，2转链后显示（不管成功or失败）
      alert_type: 'info',
      response_message: '',
      change_success: false,
      image_url: '',

      button_status: false,

      img_list: [],
      // img_list:[
      //     "http://img14.360buyimg.com/ads/jfs/t26737/341/1205287468/367337/a4f89acd/5bc430bfNef0e6aa6.jpg",
      //     "http://img14.360buyimg.com/ads/jfs/t26737/341/1205287468/367337/a4f89acd/5bc430bfNef0e6aa6.jpg",
      //     "http://img14.360buyimg.com/ads/jfs/t26737/341/1205287468/367337/a4f89acd/5bc430bfNef0e6aa6.jpg",
      //     "http://img14.360buyimg.com/ads/jfs/t26737/341/1205287468/367337/a4f89acd/5bc430bfNef0e6aa6.jpg",
      //     "http://img14.360buyimg.com/ads/jfs/t26737/341/1205287468/367337/a4f89acd/5bc430bfNef0e6aa6.jpg",
      //     "http://img14.360buyimg.com/ads/jfs/t26737/341/1205287468/367337/a4f89acd/5bc430bfNef0e6aa6.jpg",
      // ],

      //是否显示顶部返回
      isShow: false,

      skuId: '',
      show_detail_model: false,
      skuInfoData: {},

      couponData: {},

      reLoad_tag: 0,//转链失败是否重新加载
    }
  },

  created () {
    if (!this.$common.isClient_whole()) {
      if (!this.$common.gloabl_wx_openid) {
        //判断是否弹出登录界面
        let isLogin = this.$store.getters.isLogin
        this.$log('isLogin = ' + isLogin)
        if (isLogin !== true) {
          this.$bus.$emit('toLogin', '登录吧,牛宝宝')
        }
      }
    }

    this.initRobot()
  },

  mounted () {
    // this.showPasteSheet();
    if (this.$common.gloabl_wx_openid) {
      this.$wx.miniProgram.getEnv(res => {

        if (res.miniprogram) {
          this.isShow = true
        } else {
          this.isShow = false
        }
      })
    } else {
      if (this.$route.query && this.$route.query.from && this.$route.query.from === 'select') {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }

    let link_enc = this.$common.getUrlKey('link')
    if (link_enc) {
      let link = decodeURIComponent(link_enc)
      this.before_change_content = link
      this.isShow = false
    }
  },

  methods: {

    initRobot () {
      this.$getRobotList()
      this.$getAllDataListFromRobot_withLimitTime()
    },

    joinToRobot () {
      if (this.skuInfoData && this.skuInfoData.skuId) {
        this.findCoupon()
        this.$refs.Wp_join_robot_button_model.getPushStatus()
        this.$refs.Wp_join_robot_button_model.joinRobot()
        // setTimeout(()=>{
        //     // fn();
        //
        // }, 200);
      } else {
        if (this.skuId) {
          let loadingToast = Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0,
          })
          let params = {
            app_key: this.$common.getAppKeyInfo('70637').app_key,
            app_secret: this.$common.getAppKeyInfo('70637').app_secret,
            skuIds: [Number(this.skuId)],
          }

          this.$getSelectGoods(params, response => {
            if (response && response.code === 200) {
              if (response.data && response.data.length > 0) {
                let _skuInfo = response.data[0]

                //添加一个时间戳，已保证如果是同一个商品，在详情页面也能通过watch监听到
                _skuInfo.time_tag = new Date().getTime()

                this.skuInfoData = _skuInfo
                this.findCoupon()

                setTimeout(() => {
                  loadingToast.clear()
                  this.$refs.Wp_join_robot_button_model.getPushStatus()
                  this.$refs.Wp_join_robot_button_model.joinRobot()
                }, 200)
              }
            }
          })
        }
      }
    },

    /**
     * 查找优惠券
     */
    findCoupon () {
      let couponList = this.skuInfoData.couponInfo.couponList
      let _couponData = this.$common.autoFindCoupon2(couponList)
      if (_couponData) {
        this.couponData = _couponData
      }
    },

    showDetail () {
      //h5页面打开详情
      if (!this.$common.gloabl_wx_mini_user_info || !this.$common.gloabl_wx_mini_user_info.u_code) {

        if (this.skuInfoData && this.skuInfoData.skuId) {
          this.$log('----show---detail')
          this.show_detail_model = true
        } else {
          if (this.skuId) {
            let params = {
              app_key: this.$common.getAppKeyInfo('70637').app_key,
              app_secret: this.$common.getAppKeyInfo('70637').app_secret,
              skuIds: [Number(this.skuId)],
            }

            this.$getSelectGoods(params, response => {
              if (response && response.code === 200) {
                if (response.data && response.data.length > 0) {
                  let _skuInfo = response.data[0]

                  //添加一个时间戳，已保证如果是同一个商品，在详情页面也能通过watch监听到
                  _skuInfo.time_tag = new Date().getTime()

                  this.skuInfoData = _skuInfo
                  this.$log('----show---detail')
                  this.show_detail_model = true

                }
              }
            })
          }
        }

      } else {
        //小程序中，使用小程序的page打开详情
        this.$log('gloabl_wx_mini_login_status = ' + this.$common.gloabl_wx_mini_login_status)
        if (this.$common.gloabl_wx_mini_login_status) {
          if (this.$common.gloabl_wx_mini_login_status === 'none') {
            //如果登录状态为none，则需要弹出一键登录界面
            this.$log('---------需要登录---------')
            // window.location.href = "#/mini_login";

            this.navigateToLogin()
          } else {
            // if (this.$common.gloabl_wx_mini_login_status === "normal") {
            //     //如果是普通会员，并且有上级群主
            //     if (this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.f_id) {
            //         //使用上级群主的position_id进行购物
            //         this.position_id = this.$common.gloabl_wx_mini_user_info.f_id;
            //     } else {
            //         //如果没有上级群主，则给他分配一个固定群主的position_id
            //         this.position_id = "1924367099";
            //     }
            // }
            //
            // if (this.$common.gloabl_wx_mini_login_status === "super") {
            //     //如果是超级会员，并且登录了群主平台
            //     if (this.$common.getPid()) {
            //         this.position_id = this.$common.getPid();
            //     } else {
            //         if (this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.channel_id) {
            //             //使用自己的群主id进行购物
            //             this.position_id = this.$common.gloabl_wx_mini_user_info.channel_id;
            //         }
            //     }
            // }

            //跳转小程序
            let _skuId = this.skuId

            if (_skuId) {
              this.navigateToDetail(_skuId)
            }
          }
        }
      }
    },

    /**
     * 打开小程序中的详情界面
     */
    navigateToDetail (sku_str) {
      this.$common.navigateToMiniProgramPage('../wp_detail/wp_detail?', 'skuId', sku_str)
    },

    clickToCloseDetail () {
      this.show_detail_model = false
    },

    /**
     * 显示图片预览
     */
    showImagePreview () {
      ImagePreview({
        images: [
          this.image_url
        ],
        showIndex: false
      })
    },

    /**
     * 清空内容
     */
    clearContent () {
      this.before_change_content = ''
      //重置转链状态提示框
      this.show_loading = 0
    },

    /**
     * 显示"复制成功"的图章
     */
    showStamp () {
      //展示"复制成功"图章
      this.$refs.stamp_view.style.display = 'block'
    },

    /**
     * sheet上拉模板关闭时回调
     */
    sheetClosed () {
      //删除"复制成功"图章
      this.$refs.stamp_view.style.display = 'none'

      this.image_url = ''
      this.img_list = []
      this.after_change_commission = 0
      this.skuId = ''
      this.skuInfoData = {}
    },

    getClipboardContent () {
      this.$copyText()
      // let text = window.clipboard.toString()
    },

    getChangedLink_test () {
      this.alert_type = 'success'
      this.change_success = true
      this.response_message = '转链成功'
      this.show_paste_sheet_model = true
      this.after_change_content = this.before_change_content
      this.img_list = ['http://img14.360buyimg.com/ads/jfs/t1/4692/33/10292/389333/5bcad278E563a4b97/8e823bf08cd7cb00.jpg',
        'http://img14.360buyimg.com/ads/jfs/t26737/341/1205287468/367337/a4f89acd/5bc430bfNef0e6aa6.jpg',
        'http://img14.360buyimg.com/ads/jfs/t26737/341/1205287468/367337/a4f89acd/5bc430bfNef0e6aa6.jpg',
        'http://img14.360buyimg.com/ads/jfs/t1/4692/33/10292/389333/5bcad278E563a4b97/8e823bf08cd7cb00.jpg',
        'http://img14.360buyimg.com/ads/jfs/t1/4692/33/10292/389333/5bcad278E563a4b97/8e823bf08cd7cb00.jpg',
        'http://img14.360buyimg.com/ads/jfs/t1/4692/33/10292/389333/5bcad278E563a4b97/8e823bf08cd7cb00.jpg',
      ]
    },
    clickToChangedLink () {
      // this.reload_tag = 0;
      this.getChangedLink()
    },

    getChangedLink (force = false) {
      if (this.before_change_content) {
        let params = {
          content: this.before_change_content,
          pid: this.$common.getUsername(),
          // hard: "yes"
        }
        if (force) {
          params.hard = 'yes'
        }

        this.show_loading = 1
        this.alert_type = 'info'
        this.loading_text = '转链中，请稍后...'
        this.button_status = true

        let that = this

        console.log(params)

        this.$getChangeLink(params, response => {
          console.log(response)
          that.show_loading = 2
          that.button_status = false

          if (response.code === 200) {
            that.alert_type = 'success'
            that.change_success = true
            that.response_message = '转链成功'
            that.show_paste_sheet_model = true
            that.after_change_content = response.content

            this.$log(that.after_change_content)

            if (that.after_change_content && that.after_change_content.indexOf('更多优惠') !== -1) {
              let last_line = that.after_change_content.substring(that.after_change_content.indexOf('更多优惠'))

              if (last_line.indexOf('.wapg.cn')) {
                let temp_content = that.after_change_content.substring(0, that.after_change_content.lastIndexOf('更多优惠'))

                let second_host_url = 'http://' + this.$store.state.username + '.wapg.cn'
                temp_content += '更多优惠: ' + second_host_url.toLowerCase()

                that.after_change_content = temp_content
              }
            }

            if (response.commission > 0) {
              that.after_change_commission = response.commission.toFixed(2)
            } else {
              that.after_change_commission = 0
            }

            // this.image_url = response.imgList[0];
            if (response.imgList) {
              for (let i = 0; i < response.imgList.length; i++) {
                let img = response.imgList[i]
                that.img_list.push(img)
              }
              // this.$log("response.imgList = " + response.imgList);
              // this.$log("type = " + typeof response.imgList);
              //
              // that.img_list = response.imgList;
            }
            //
            // if(response.imgList && response.imgList.length === 1){
            //     this.image_url = response.imgList[0];
            // }
            if (response.sku_id) {
              this.skuId = response.sku_id
            }
            // this.skuId = '43607189550';

          } else if (response.code === 0) {
            that.alert_type = 'error'
            that.response_message = '转链服务器暂无响应'
          } else if (response.code >= 500) {
            that.alert_type = 'error'
            that.response_message = response.message
          } else if (response.toString().indexOf('Error') !== -1) {
            if (response.toString().indexOf('timeout') !== -1) {
              that.alert_type = 'error'
              that.response_message = '转链超时，请重试'
            } else {
              that.alert_type = 'error'
              that.response_message = '转链错误，请重试:\n' + response.toString()
            }

          }
        }, error => {
          //暂不区分超时错误
          that.alert_type = 'error'
          that.response_message = '转链错误，请重试:\n' + error.toString()
          if (this.reLoad_tag < 1) {
            this.getChangedLink(true)
            this.reLoad_tag++
          } else {
            this.reLoad_tag = 0
          }
        })
        // this.show_paste_sheet_model = false;
        setTimeout(() => {
          this.loading_text = '转链操作较为耗时，请耐心等待...'
        }, 5000)
      }
    },
    onCopySuccess () {
      this.showStamp()
      // setTimeout(() => {
      //     this.$notify({
      //         message: '\n复制成功\n ',
      //         duration: 2000,
      //         background: '#1989fa'
      //     });
      //
      // }, 500);
      Toast.success({
        message: '复制成功'
      })
    },
    onError () {
      // setTimeout(() => {
      //     this.$notify({
      //         message: '\n复制失败\n ',
      //         duration: 2000,
      //     });
      // }, 500);
      Toast.fail({
        message: '复制失败'
      })
    },
  }
}
</script>

<style scoped>

</style>
